import { Hourglass } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Página de módulo ainda não implementado. Mantém o mesmo cabeçalho das
 * páginas reais pra que a navegação não pareça quebrada.
 */
export default function EmBreve({
  titulo,
  subtitulo,
  icone,
  descricao,
}: {
  titulo: string;
  subtitulo: string;
  icone: ReactNode;
  descricao: string;
}) {
  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto">
      <header className="mb-6 flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-primary-soft/40 text-primary flex items-center justify-center">
          {icone}
        </div>
        <div>
          <h1 className="text-2xl font-bold text-fg">{titulo}</h1>
          <p className="text-sm text-fg-2">{subtitulo}</p>
        </div>
      </header>

      <div className="bg-surface border border-line rounded-2xl p-10 text-center">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-canvas text-muted flex items-center justify-center mb-4">
          <Hourglass size={26} />
        </div>
        <h2 className="text-lg font-semibold text-fg">Em breve</h2>
        <p className="text-sm text-muted mt-1 max-w-md mx-auto">{descricao}</p>
      </div>
    </div>
  );
}
